// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indicators {
    padding: 10px;
}
.indicators ul, .indicators li {
    list-style-type: none;
    margin: 0;
    padding: 0;
}
.indicators ul ul {
    padding-left: 15px;
}
.indicators li {
    margin-bottom: 2px;
    padding-bottom: 2px;
}
.indicators > ul > li {
    border-bottom: 1px solid #dcdcdc;
    margin-bottom: 3px;
}
.indicators li div {
    margin-left: 0px;
}
.indicators li span.indicatorobject {
    display: inline-block;
    margin-right: 3px;
    border-radius: 2px;
    background-color: #ddd;
    padding: 1px 5px;
    font-size: .9em;
    cursor: pointer;
}
.indicators li span.indicatorobject.active {
    background-color: #595959;
    color: #fff;
}

.indicator-legend-image img {
    width: 100%;
}
.indicator-legend td {
    text-align: center;
}
.indicator-legend {
    width: 100%;
}
.indicator-legend .color {
    display: inline-block;
    width: 20px;
    height: 20px;
    border: 1px solid #ccc;
}
.indicator-timeslices {
    width: 100%;
}
.indicator-timeslices span {
    cursor: pointer;
    display: block;
    text-align: center;
    padding: 2px 5px;
}
.indicator-timeslices span:hover {
    background-color: #ddd;
}
.indicator-timeslices span.active, .indicator-timeslices span.active:hover {
    background-color: #595959;
    color: #fff;
}
.indicatortogglename {
    display: flex;
    align-items: stretch;
    gap: 5px;
}
.indicatortogglename span {
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./js/style/Indicators.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,aAAa;IACb,oBAAoB;IACpB,QAAQ;AACZ;AACA;IACI,iBAAiB;AACrB","sourcesContent":[".indicators {\n    padding: 10px;\n}\n.indicators ul, .indicators li {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n.indicators ul ul {\n    padding-left: 15px;\n}\n.indicators li {\n    margin-bottom: 2px;\n    padding-bottom: 2px;\n}\n.indicators > ul > li {\n    border-bottom: 1px solid #dcdcdc;\n    margin-bottom: 3px;\n}\n.indicators li div {\n    margin-left: 0px;\n}\n.indicators li span.indicatorobject {\n    display: inline-block;\n    margin-right: 3px;\n    border-radius: 2px;\n    background-color: #ddd;\n    padding: 1px 5px;\n    font-size: .9em;\n    cursor: pointer;\n}\n.indicators li span.indicatorobject.active {\n    background-color: #595959;\n    color: #fff;\n}\n\n.indicator-legend-image img {\n    width: 100%;\n}\n.indicator-legend td {\n    text-align: center;\n}\n.indicator-legend {\n    width: 100%;\n}\n.indicator-legend .color {\n    display: inline-block;\n    width: 20px;\n    height: 20px;\n    border: 1px solid #ccc;\n}\n.indicator-timeslices {\n    width: 100%;\n}\n.indicator-timeslices span {\n    cursor: pointer;\n    display: block;\n    text-align: center;\n    padding: 2px 5px;\n}\n.indicator-timeslices span:hover {\n    background-color: #ddd;\n}\n.indicator-timeslices span.active, .indicator-timeslices span.active:hover {\n    background-color: #595959;\n    color: #fff;\n}\n.indicatortogglename {\n    display: flex;\n    align-items: stretch;\n    gap: 5px;\n}\n.indicatortogglename span {\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
